import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * CAPTCHA component for authentication forms (reCAPTCHA v2).
 */
const Captcha = forwardRef(
  ({ onVerify, onExpire, onError, siteKey, theme = 'light', size = 'normal' }, ref) => {
    const recaptchaRef = useRef(null);
    const [isVerified, setIsVerified] = useState(false);
    const [error, setError] = useState(null);

    const handleVerify = (token) => {
      if (token) {
        setIsVerified(true);
        setError(null);
        onVerify?.(token);
      }
    };

    const handleExpire = () => {
      setIsVerified(false);
      onExpire?.();
    };

    const handleError = () => {
      setIsVerified(false);
      setError('CAPTCHA verification failed. Please try again.');
      onError?.();
    };

    const resetCaptcha = () => {
      recaptchaRef.current?.reset();
      setIsVerified(false);
      setError(null);
    };

    useImperativeHandle(ref, () => ({
      reset: resetCaptcha,
      isVerified: () => isVerified,
    }));

    if (!siteKey) {
      return null;
    }

    return (
      <div className="captcha-container">
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={handleVerify}
          onExpired={handleExpire}
          onErrored={handleError}
          theme={theme}
          size={size}
        />
        {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
      </div>
    );
  }
);

Captcha.displayName = 'Captcha';

export default Captcha;
